import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { staticDropdownActions as actions } from './staticDropdownStore';

export const useStaticDropdownState = () =>
  useSelector((state) => state.dropdown);

export const useStaticDropdownAction = () => {
  const dispatch = useDispatch();

  const onToggleDropdown = useCallback((id) => {
    dispatch(actions.setDropdown({ id }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { onToggleDropdown };
};
